import { render, staticRenderFns } from "./Comissão.vue?vue&type=template&id=29b1b850&scoped=true"
import script from "./Comissão.vue?vue&type=script&lang=js"
export * from "./Comissão.vue?vue&type=script&lang=js"
import style0 from "./Comissão.vue?vue&type=style&index=0&id=29b1b850&prod&lang=css"
import style1 from "./Comissão.vue?vue&type=style&index=1&id=29b1b850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1b850",
  null
  
)

export default component.exports